module.exports = __webpack_public_path__ + "static/media/sharepageImage.11010672.svg";